import Link from "next/link";
import { Container } from "@/components/container";
import { LogoFull } from "@/components/logo";

/**
 * SlimFooter (§6.2): minimal footer for conversion / 404 / 500 pages.
 */
export function SlimFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-background">
      <Container className="flex flex-col items-center gap-4 py-8 text-sm text-muted-foreground sm:flex-row sm:justify-between">
        <div className="flex items-center gap-3">
          <LogoFull className="text-base" />
          <span className="text-xs">© {year} All rights reserved.</span>
        </div>
        <div className="flex items-center gap-4">
          <Link href="/privacy" className="transition-colors hover:text-foreground">
            Privacy
          </Link>
          <Link href="/terms" className="transition-colors hover:text-foreground">
            Terms
          </Link>
          <Link href="/contact" className="transition-colors hover:text-foreground">
            Contact
          </Link>
        </div>
      </Container>
    </footer>
  );
}
